
import Icon from 'JS/components/Icon.vue';
import { computed, defineComponent } from 'vue';
import { useOrderStore } from '../state/order';
import { WorkOrderType } from '../types/session';

export default defineComponent({
	name: 'SchedulerHeader',
	components: {
		Icon,
	},
	props: {
		title: { type: String, default: '' }
	},
	setup() {
		const orderStore = useOrderStore();
		const orderType = computed<WorkOrderType>(() => orderStore.session?.type);
		const productBlainNumber = computed(() => orderStore.session?.workOrderSummary?.product?.blainNumber);

		const backUrl = computed(() => {
			if (orderType.value == WorkOrderType.ServiceOnly) {
				return '/automotive-service-repair/';
			}

			if (productBlainNumber.value) {
				return '/products/' + productBlainNumber.value;
			}

			switch (orderType.value) {
				case WorkOrderType.Tire:
					return '/tires/';
				case WorkOrderType.Battery:
					return '/batteries/';
			}

			// should not be reachable
			return '/automotive-service/';
		});

		return {
			backUrl
		};
	}
});
